import React, { FC } from 'react';
import styled from 'styled-components';
import { useT } from '@hooks';

const Container = styled.div`
	background: ${({ theme }) => theme.colors.bg10};
	border-radius: 16px;
	padding: 16px;

	p {
		font-size: 14px;
		line-height: 19px;
		color: ${({ theme }) => theme.colors.text21};
	}

	p:first-child {
		color: ${({ theme }) => theme.colors.text1};
		font-weight: 700;
	}

	a {
		color: ${({ theme }) => theme.colors.text14};
		text-decoration: underline;
	}
`;

export const Support: FC = () => {
	const { T } = useT();

	return (
		<Container>
			<p>{T('payment_text_6_15')}</p>
			<p dangerouslySetInnerHTML={{ __html: T('payment_text_6_16') }}></p>
		</Container>
	);
};
